import { render, staticRenderFns } from "./ServiceSubType.vue?vue&type=template&id=62f5e1ce&"
import script from "./ServiceSubType.vue?vue&type=script&lang=js&"
export * from "./ServiceSubType.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSubType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports